// src/components/casino/GameIframe.jsx
import React, { useState, useEffect } from 'react';

const GameIframe = ({ url, onClose, gameName, sessionId }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        if (window.confirm('Are you sure you want to exit the game?')) {
          onClose();
        }
      }
    };
    
    window.addEventListener('keydown', handleEscape);
    
    const handleMessage = (event) => {
      if (event.data?.type === 'game_closed') {
        onClose();
      }
    };
    
    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('keydown', handleEscape);
      window.removeEventListener('message', handleMessage);
    };
  }, [onClose]);

  const handleExitClick = () => {
    if (window.confirm('Are you sure you want to exit the game?\nYour balance will be unlocked.')) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black">
      <div className="bg-gray-900/95 backdrop-blur-sm p-4 flex items-center justify-between border-b border-gray-800">
        <div className="flex items-center gap-3">
          <span className="text-2xl">🎰</span>
          <span className="text-white font-semibold">{gameName || 'Casino Game'}</span>
          {sessionId && (
            <span className="text-xs text-gray-500">Session: {sessionId.substring(0, 8)}</span>
          )}
        </div>
        <button
          onClick={handleExitClick}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors flex items-center gap-2"
        >
          ✕ Exit Game
        </button>
      </div>
      
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-purple-500"></div>
            <p className="text-gray-400 mt-4">Loading game...</p>
            <p className="text-gray-600 text-sm">Please wait</p>
          </div>
        </div>
      )}
      
      <iframe
        src={url}
        className="w-full h-[calc(100vh-72px)] border-0"
        allow="autoplay; fullscreen"
        onLoad={() => setLoading(false)}
        title="Casino Game"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals"
      />
      
      <div className="absolute bottom-0 left-0 right-0 bg-gray-900/80 backdrop-blur-sm p-2 text-center border-t border-gray-800">
        <p className="text-xs text-gray-500">
          🔒 Secure session • Your balance is locked • Close the game to release funds
        </p>
      </div>
    </div>
  );
};

export default GameIframe;